import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const brandRouter: Array<RouteConfig> = [
  {
    path: "brands_list",
    name: "brands_list",
    component: () => import("@/views/Brands/BrandsList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "brands_list/:id",
    name: "brandId",
    component: () => import("@/views/Brands/Brand.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "brands_list/create_brand",
    name: "new_brand",
    component: () => import("@/views/Brands/NewBrand.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "vehicle_model",
    name: "vehicle_model",
    component: () => import("@/views/Models/ModelsList.vue")
  }
];

export default brandRouter;
